import React, { useMemo } from 'react';
import OrganizationAnalyticsLineChart from './OrganizationAnalyticsLineChart';
import { formatTimeCategoriesByRange, mapIdsToLabels } from './chartUtils';

const OrganizationInfluencerTotalEarningsByTimeChart = ({ data, influencerLabelMap, dateRange, pending }) => {
  const { categories, series } = useMemo(
    () => ({
      categories: formatTimeCategoriesByRange(data?.time || [], dateRange),
      series: (data?.series || []).map(item => ({
        name: mapIdsToLabels([item.influencerId], influencerLabelMap)[0],
        data: item.totalEarnings || [],
      })),
    }),
    [data, influencerLabelMap, dateRange],
  );

  return (
    <OrganizationAnalyticsLineChart
      title="Total Earnings Over Time"
      subtitle="Earnings trend for the selected creators."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select one or more creators to load earnings over time."
    />
  );
};

export default OrganizationInfluencerTotalEarningsByTimeChart;
